import { ChevronsUpDown, LoaderCircle } from 'lucide-react';
import React from 'react';

import { cn } from 'src/lib/utils';

interface SelectLoadingProps {
  className?: string;
  loadingText?: string;
}

export function SelectLoading({ className, loadingText = '加载中...' }: SelectLoadingProps) {
  return (
    <div
      className={cn(
        'flex items-center justify-between gap-2 min-h-9 w-full px-3 py-1',
        'rounded-md border border-input bg-transparent text-sm shadow-xs',
        'cursor-not-allowed opacity-50',
        className
      )}
      tabIndex={-1}
    >
      <div className="flex-1 min-w-0 overflow-hidden flex items-center gap-2">
        <LoaderCircle className="size-4 animate-spin opacity-50" />
        <span className="text-muted-foreground">{loadingText}</span>
      </div>
      <ChevronsUpDown className="w-4 h-4 opacity-50" />
    </div>
  );
}
